/** Administradores de la empresa (T085 · US7). */
import { createFileRoute } from '@tanstack/react-router';

import { AdminsPage } from '../../features/admins/admins-page';

export const Route = createFileRoute('/_app/administradores')({
  component: AdminsPage,
});
